import styled from 'styled-components'

export default styled.img`
  width: 45px;
`
